// Indexa as evidências já persistidas por id da resposta, formato consumido
// pelo PrivacyByDesignEvidenceField.
const buildEvidencesMap = (privacyByDesign) => {
  const map = {}

  const questions = privacyByDesign?.questions || []

  questions.forEach((question) => {
    const answer = question.privacyByDesignAnswers?.[0]
    if (answer) map[answer.id] = answer.evidences || []
  })

  return map
}

export default buildEvidencesMap
